import React from "react";

import { markdownify } from "config/utils";

import Accordion from "components/Accordion";

import { Wrapper, Count, Title, Summary, Text, Icon } from "./styles";

const Step = ({ content, count }) => {
  return (
    <Wrapper>
      <Count>{count}</Count>
      {content.icon && (
        <Icon src={`/img/${content.icon.relativePath}`} alt="" />
      )}
      <Title>{content.title}</Title>
      {content.summary && <Summary>{content.summary}</Summary>}
      {content.items.length > 1 ? (
        content.items.map((item, index) => (
          <Accordion key={index} content={item} size="small" />
        ))
      ) : (
        <Text
          dangerouslySetInnerHTML={{
            __html: markdownify(content.items[0].text)
          }}
        />
      )}
    </Wrapper>
  );
};

export default Step;
